import { Typography } from "@mui/material";
import type { TextObjectFilter } from "../../api/types/objectTypes";
import { getTextFilterValuesText, textFilterOperatorCaptions } from "./objectFilterHelpers";

interface Props {
  fieldName: string;
  filter: TextObjectFilter;
  startLabel: string;
}

const ObjectTextFilterDescription = ({ fieldName, filter, startLabel }: Props) => {
  return (
    <Typography>
      {startLabel} <strong>{fieldName}</strong> {textFilterOperatorCaptions[filter.operator] ?? filter.operator}{" "}
      <strong>{getTextFilterValuesText(filter)}</strong>
    </Typography>
  );
};

export default ObjectTextFilterDescription;
